"use client";

import { useSyncExternalStore } from "react";
import { isStandaloneDisplayMode } from "../pwa";

const NATIVE_READY_EVENT = "award-party:native-ready";

export function readInstalledAppShell(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const navigatorStandalone =
    "standalone" in window.navigator
      ? Boolean(
          (window.navigator as Navigator & { standalone?: boolean }).standalone,
        )
      : undefined;

  return (
    isStandaloneDisplayMode(
      (query) => window.matchMedia(query).matches,
      navigatorStandalone,
    ) ||
    document.documentElement.classList.contains("ap-standalone") ||
    document.documentElement.dataset.awardPartyNativeShell === "true"
  );
}

function subscribeInstalledAppShell(onChange: () => void): () => void {
  const mediaQueries = [
    "(display-mode: standalone)",
    "(display-mode: fullscreen)",
    "(display-mode: minimal-ui)",
    "(display-mode: window-controls-overlay)",
  ].map((query) => window.matchMedia(query));

  for (const media of mediaQueries) {
    media.addEventListener("change", onChange);
  }
  window.addEventListener(NATIVE_READY_EVENT, onChange);

  return () => {
    for (const media of mediaQueries) {
      media.removeEventListener("change", onChange);
    }
    window.removeEventListener(NATIVE_READY_EVENT, onChange);
  };
}

export function useStandaloneDisplay(): boolean {
  return useSyncExternalStore(
    subscribeInstalledAppShell,
    readInstalledAppShell,
    () => false,
  );
}
